import { render, staticRenderFns } from "./Claimant.vue?vue&type=template&id=33c54c4e&"
import script from "./Claimant.vue?vue&type=script&lang=js&"
export * from "./Claimant.vue?vue&type=script&lang=js&"
import style0 from "./Claimant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Claimant.vue"
export default component.exports